import Contact from "../anexo/contact";

export default function Footer(){
  return(
    <footer>
      <div>
        <h5> Anchors </h5>
        <ul>
          <li> <a href='#about' rel='noreferrer noopener' > <small>About</small> </a> </li>
          <li> <a href='#skills' rel='noreferrer noopener' > <small>Skills</small> </a> </li>
          <li> <a href='#services' rel='noreferrer noopener' > <small>Services</small> </a> </li>
          <li> <a href='#portfolio' rel='noreferrer noopener' > <small>Portfolio</small> </a> </li>
          <li> <a href='#clients' rel='noreferrer noopener' > <small>Clients</small> </a> </li>
        </ul>  
      </div>
      
      <div className="rights">
      <div>
        <h5> Follow/Get in touch with me </h5>
        <Contact/>
      </div>
        <h1> AlfeuX </h1>
        <small> &copy; 2022-2024</small>
        <br/>
        <small>All rights reserved ®</small>
      </div>
      
    </footer>
  );
}